module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg6-4fc1c31c0ade15a4ec6cd1641ee741c9.svg";